var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2947 8.53036C11.0218 8.25742 10.57 8.25742 10.2971 8.53036L8.67825 10.1492V5.26448C8.67825 4.87859 8.35825 4.55859 7.97237 4.55859C7.58649 4.55859 7.26649 4.87859 7.26649 5.26448V10.1492L5.64766 8.53036C5.37472 8.25742 4.92296 8.25742 4.65002 8.53036C4.37708 8.8033 4.37708 9.25506 4.65002 9.52801L7.47355 12.3515C7.61472 12.4927 7.79355 12.5586 7.97237 12.5586C8.15119 12.5586 8.33002 12.4927 8.47119 12.3515L11.2947 9.52801C11.5677 9.25506 11.5677 8.8033 11.2947 8.53036Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.9340231011d50b94d40514ce1a11e7a2.svg";
export { ForwardRef as ReactComponent };